<app-card [titleKey]="'general.basicData'">
  @if (loading()) {
  <div class="placeholder-glow">
    @for (_ of [1,2,3,4,5]; track $index) {
    <div class="mb-3">
      <span class="placeholder col-3 d-block mb-2 rounded"></span>
      <span
        class="placeholder w-100 d-block rounded"
        style="height: 38px"
      ></span>
    </div>
    }
  </div>
  } @else {
  <app-card [titleKey]="'newProjectIdea.placeOfProject'" class="mt-4">
    <div class="col-auto my-2 mb-4">
      <app-validated-dropdown
        [label]="'general.country'"
        [inputFormControlName]="'country'"
        [inputFormControl]="form.controls.country"
        [leaveSpaceForValidation]="true"
        [loading]="!genericStore.allLoaded()"
        [optionsStamp]="genericStore.countriesEntities().length"
      >
        <option
          *ngFor="let country of genericStore.countriesEntities()"
          [value]="country.code"
        >
          {{ country.localized | getLocalized }}
        </option>
      </app-validated-dropdown>
    </div>

    <div class="col-auto my-2 mb-4">
      <app-validated-input
        [label]="'general.city'"
        [inputFormControlName]="'city'"
        [inputFormControl]="form.controls.city"
        [leaveSpaceForValidation]="true"
      />
    </div>
  </app-card>

  <div class="col-auto my-2 mb-4">
    <app-validated-dropdown
      [label]="'newProjectIdea.collectionCurrency'"
      [inputFormControlName]="'collectionCurrency'"
      [inputFormControl]="form.controls.collectionCurrency"
      [leaveSpaceForValidation]="true"
      [loading]="!genericStore.allLoaded()"
      [optionsStamp]="genericStore.currenciesEntities().length"
    >
      <option
        *ngFor="let currency of genericStore.currenciesEntities()"
        [value]="currency.code"
      >
        {{ currency.localized | getLocalized }}
      </option>
    </app-validated-dropdown>
  </div>

  <app-validated-input
    [label]="'general.projectTitle'"
    inputFormControlName="projectTitle"
    [inputFormControl]="form.controls.projectTitle"
    [leaveSpaceForValidation]="true"
  >
  </app-validated-input>

  <app-validated-textarea
    [label]="'newProjectIdea.shortProjectIntroduction'"
    inputFormControlName="projectIntroduction"
    [inputFormControl]="form.controls.projectIntroduction"
    [rows]="10"
    [maxLength]="2000"
    [leaveSpaceForValidation]="true"
  >
  </app-validated-textarea>

  <app-upload-files
    class="file-upload"
    [formControls]="form.controls.files"
    [title]="'newProjectIdea.connectingFiles'"
    [canAdd]="true"
    [showIsPublicCheckbox]="true"
    (createNewFileGroup)="createNewFileGroup(form.controls.files)"
    (fileRemoved)="removeFileGroup($event)"
  />
  }
</app-card>
